import React, { ReactNode, createContext, useContext } from 'react';
import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { FormProvider, useForm } from 'react-hook-form';
import { useWatch } from 'react-hook-form';

import { DateTime } from 'luxon';
import cuid from 'cuid';

import { where } from 'firebase/firestore';

import { useAuthData } from 'stuff';
import { useCollection, useCollectionConditionally, 
	useUpdateDocProperty, useUploadFile, useWrite } from 'ember';


import { Certification, CertificationFor, CertificationRecord, StorageFile} from 'models';
import { User, Asset, CorComponent } from 'models';






export interface CertificationData
{
	certificationRecords?: CertificationRecord[],
	certification: Certification,
	current_certifications: Certification[],
	users: User[],
	assets: Asset[],
	components?: CorComponent[],
	files?: StorageFile[],

	certification_option: string[],
	
	uploadFiles?: Function,
	handleSubmit?: any
	
}


const DEFAULT_FORM_DATA: Certification = 
{
	_id: cuid(),

	certification_for: null,
	name: '',
	category: '',
	type: '',
	lead_time_in_days: null,
	is_required_to_operate: null,
	is_physical_copy_required: null,
	
}


//to pass to select as option for certification
const certification_option = [
	'User', 'Asset'
]


const CertificationDataContext = createContext<CertificationData>(null);


export const useCertification = () =>
{
	return useContext(CertificationDataContext)
};


const CertificationDataProvider = ({
	certification,
	children,
} : {
	certification?: Certification,
	children?: ReactNode,
}) =>
{
	
	const { claims } = useAuthData();
	
	// const current_user = {
	// 	_id: claims.user_id,
	// 	name: claims.name,
	// 	email: claims.email,
	// }
	
	
	const uploadFile = useUploadFile();
	const write = useWrite();
	const navigate = useNavigate();
	const updateDocProperty = useUpdateDocProperty();
	
	const datetime = DateTime.utc().toISO();
	
	
	const form = useForm<Certification>({
		defaultValues: {
			...DEFAULT_FORM_DATA,
			...certification,
		},
	});
	
	const form_values = form.getValues();
	console.log({form_values});
	
	
	const { control } = form;
	
	
	const handleSubmit = async (e) =>
	{
		e.preventDefault();
		
		const form_values = form.getValues();
				

		//if edit rather than creation then we keep same _id, else we cuid() and create new
		const new_certification_data: Certification = certification
			? { ...form_values }
			: { ...form_values, _id: cuid() };

		
		console.log ("Hello certification form values:" + {form_values})

		

		const new_form_values: Certification = {
				_id: new_certification_data?._id || '',
				certification_for: new_certification_data?.certification_for || null,
				name: new_certification_data?.name || '',
				category: new_certification_data?.category || '',
				type: new_certification_data?.type || '',
				lead_time_in_days: new_certification_data?.lead_time_in_days || null,
				is_required_to_operate: new_certification_data?.is_required_to_operate || null,
				is_physical_copy_required: new_certification_data?.is_physical_copy_required || null
		}


		write(`organizations/${claims.organization_id}/certifications`, new_form_values);

	

		
		// writeRequisitionDataOnCreation(values, write, current_user, claims, uploadFile, navigate);

	}
	
	
	const org_path = `organizations/${claims.organization_id}`;
	
	
	const users_collection = useCollection(`${org_path}/users`);
	
	
	const assets_collection = useCollection(`${org_path}/assets`);
	
	//check the file logic again as we try to load all attachments with certifications at once
	const files_collection = useCollectionConditionally(
		(certification !== undefined),
		`${org_path}/files`,
		where('certification_id', '!=', '')
	);
	
	//existing certificates
	const certifications_collection = useCollection(`${org_path}/certifications`);



	
	//later add component collection 
	
	const files = files_collection?.data as StorageFile[] || [];
	const users = users_collection?.data as User[] || [];
	const assets = assets_collection?.data as Asset[] || [];

	const current_certifications = certifications_collection?.data as Certification[] || []
	
	
	
	//to handle uploading attachments
	const uploadFiles = (file_list: FileList | null) =>
	{
		// uploadFilesRequisition(
		// 	file_list,
		// 	claims,
		// 	uploadFile,
		// 	requisition,
		// 	write
		// )
		
	};
	
	//maaybe error?
	const certification_data = 
	{
		current_certifications: current_certifications,
		certification: certification,
		users: users || [],
		assets: assets || [],
		components: [],
		files: files || [],

		certification_option: certification_option,
		
		uploadFiles: uploadFiles,
		handleSubmit: handleSubmit
	
	}
	
	
	return (
		
		<FormProvider {...form}>
			
			
			<CertificationDataContext.Provider
				value = {certification_data}
			>	
			
				<form
					onSubmit={handleSubmit}
				>
					{children}
				</form>		
								
			</CertificationDataContext.Provider>
			
			
		</FormProvider>
		
		
	)
	
	
	
	
}

export default CertificationDataProvider